import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { afterPayoutSetup } from '@/lib/setupSteps'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { RefreshCw } from 'lucide-react'
import athleteApi from '../lib/api'
import { useState } from 'react'
import { toast } from '@/components/ui/sonner'

const StripeRefresh = () => {
  const navigate = useNavigate()
  const { athlete } = useAuth()
  const [loading, setLoading] = useState(false)

  const handleRefresh = async () => {
    setLoading(true)
    try {
      const response = await athleteApi.post('/athlete/stripe/refresh-link')
      const { url } = response.data

      // Redirect to the new Stripe onboarding URL
      window.location.href = url
    } catch (error: unknown) {
      console.error('Error refreshing link:', error)

      // Check if account is already complete
      if (error && typeof error === 'object' && 'response' in error) {
        const axiosError = error as { response?: { data?: { status?: string } } }
        if (axiosError.response?.data?.status === 'complete') {
          toast('Already Connected', {
            description: 'Your account is already connected and enabled for payouts.',
          })
          navigate(afterPayoutSetup(athlete))
          return
        }
      }

      toast.error('Error', {
        description: 'Failed to refresh onboarding link. Please try again.',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <Card variant="dark" className="max-w-md w-full overflow-hidden">
        <CardHeader className="text-center pb-4">
          <div className="mx-auto mb-4 p-6 rounded-full bg-yellow-500/20 border border-yellow-500/30">
            <RefreshCw className="h-12 w-12 text-yellow-600" />
          </div>
          <CardTitle className="text-foreground text-xl mb-2">Link Expired</CardTitle>
          <CardDescription className="text-gray-600">
            Your Stripe onboarding link has expired. Click below to generate a new link and
            continue setting up your account.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <button
            onClick={handleRefresh}
            disabled={loading}
            className="w-full px-6 py-3 bg-[#C0FD72] text-black rounded-md hover:bg-[#d2ff9c] font-medium disabled:opacity-50"
          >
            {loading ? (
              <span className="flex items-center justify-center">
                <span className="mr-2 h-4 w-4 animate-spin rounded-full border-2 border-black border-t-transparent"></span>
                Generating new link...
              </span>
            ) : (
              'Continue Setup'
            )}
          </button>
          <button
            onClick={() => navigate(afterPayoutSetup(athlete))}
            className="w-full px-6 py-3 bg-transparent text-gray-600 hover:text-foreground rounded-md font-medium"
          >
            Back to Earnings
          </button>
        </CardContent>
      </Card>
    </div>
  )
}

export default StripeRefresh
